import { defineStore } from 'pinia'
import { ref, onUnmounted } from 'vue'

import { useRoutingStore } from '../store';

export const useWebSocketStore = defineStore('websocket', () => {
  
  const socket = ref(null)
  const isConnected = ref(false)
  const isRegistered = ref(false)
  const messages = ref([])
  const lastMessage = ref(null) // последнее сообщение
  const eventListeners = new Map()

  let myGuid
  let parentGuid

  const routingStore = useRoutingStore()  

  const send = (targetGuid, content) => {

    if (!isRegistered.value) {
      console.log('Сначала зарегистрируйтесь')
      return false
    }

    if (!socket.value || !isConnected.value) {
      console.log('Нет подключения к вебсокету')
      return false
    }

    const message = {
      type: 'send_to_client',
      targetGuid: targetGuid,
      content: content
    };

    socket.value.send(JSON.stringify(message))
  }

  const disconnect = () => {
    if (socket.value) {
      socket.value.close()
    }
  }

  const on = (event, callback) => {
    if (!eventListeners.has(event)) {
      eventListeners.set(event, new Set())
    }
    eventListeners.get(event).add(callback)
    
    // Возвращаем функцию для отписки
    return () => {
      const listeners = eventListeners.get(event)
      if (listeners) {
        listeners.delete(callback)
      }
    }
  }

  const emitEvent = (event, data) => {
    const listeners = eventListeners.get(event)
    if (listeners) {
      listeners.forEach(callback => callback(data))
    }
  }

  const register = () => {
    if (!socket.value || socket.value.readyState !== WebSocket.OPEN) {
      console.log('Сначала подключитесь к серверу')
      return false
    }
    
    const message = {
      type: 'register',
      guid: myGuid
    };
    
    socket.value.send(JSON.stringify(message))
    console.log(`Отправлен запрос на регистрацию с Guid: ${myGuid}`)

    return true;
  }

  onUnmounted(() => {
    disconnect()
  })

  const connect = (url, param_myGuid, param_parentGuid) => {
    
    myGuid = param_myGuid
    parentGuid = param_parentGuid

    socket.value = new WebSocket(url)
    
    socket.value.onopen = () => {
      console.log('WebSocket подключен')
      register()
      isConnected.value = true
      emitEvent('connected')
    }

    socket.value.onclose = () => {
      isRegistered.value = false;
      console.log('WebSocket отключен');
      
      // Автопереподключение через 3 секунды
      setTimeout(connect, 3000);

      isConnected.value = false
      emitEvent('disconnected')
    }

    socket.value.onerror = (error) => {
      console.error('WebSocket ошибка:', error)
      emitEvent('error', error)
    }

    socket.value.onmessage = (event) => {
      try 
        {
          console.log('Получено сообщение event:', event);

          const data = JSON.parse(event.data);
          console.log('Получено сообщение:', data);

          switch(data.type) {
              case 'registered':
                  if (data.status === 'success') {
                      isRegistered.value = true;
                      console.log(`Успешно зарегистрирован с Guid: ${myGuid}`);
                  }
                  break;
                  
              case 'message':
                  console.log(`Сообщение получено от клиента: ${data.fromGuid}`);

                  if (data.content.messageType === 'mapData') {
                      
                      let startPoint = data.content.data.startPoint;
                      let points = data.content.data.points;

                      // Сохраняем сообщение в store
                      messages.value.push(data)
                      lastMessage.value = data                      

                      //routingStore.RLWaypoints.value = points;
                      //map.setCenter(startPoint.coordinates, 13);
                      
                      // стартовая метка
                      // const startPlacemark = new ymaps.Placemark(startPoint.coordinates, { balloonContent: "Старт" }, { preset: "islands#greenDotIcon" });
                      // map.geoObjects.add(startPlacemark);

                      // обычные точки
                      // points.forEach((point, i) => {
                      //     const pm = new ymaps.Placemark(point.coordinates, { balloonContent: point.name }, { preset: "twirl#blueIcon" });
                      //     myCollection.add(pm);
                      // });
                      // map.geoObjects.add(myCollection);
                      // map.geoObjects.add(SelCollection);
                  }

                  break;
                  
              case 'message_sent':
                  console.log(`Сообщение доставлено клиенту: ${data.targetGuid}`);
                  break;
                  
              case 'error':
                  console.log(data.message);
                  break;
                  
              case 'pong':
                  console.log('Pong received:', data.timestamp);
                  break;
          }
          
      } catch (error) {
          console.error('Ошибка парсинга сообщения:', error);
      }

      // messages.value.push(data)

      // Эмитим события по типу сообщения
      // if (data.type) {
      //   emitEvent(data.type, data)
      // }
    }
    
  }

  return {
    socket,
    isConnected,
    isRegistered,
    messages,
    lastMessage,    
    connect,
    disconnect,
    send,
    on
  }
})